<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>

    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>分播机配置（配置仅对中分位分播生效）</div>
        </div>
        <div style="padding: 20px 25px 0">
          <el-form :inline="true" :model="cutSettingForm">
            <el-form-item label="中分位分播并自动汇集">
              <el-switch v-model="cutSettingForm.auto_collect"></el-switch>
            </el-form-item>
            <el-form-item label="格口单次落入件数">
              <el-input-number
                v-model="cutSettingForm.grid_piece_num"
                :min="1"
                :max="1000"
              ></el-input-number>
            </el-form-item>
            <el-col :span="24">
              <el-form-item label="中分位分播时单件波次是否进入指定格口号">
                <el-switch
                  v-model="cutSettingForm.single_grid"
                  @change="handleChangeOpen"
                ></el-switch>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="cutSettingForm.grid_no"
                  :disabled="cutSettingForm.single_grid"
                  placeholder="格口号"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="中分位分播时部分板位粗分">
                <el-switch v-model="cutSettingForm.open_rough"></el-switch>
                <span>
                  （功能开启后以下中分位分组将进行粗分并进入指定格口）
                </span>
              </el-form-item>
              <el-tag
                v-for="(tag, index) in cutSettingForm.rough_grid"
                :key="'tag-' + tag.grid_no + '-' + index"
                :disable-transitions="false"
                closable
                style="
                  margin: 10px 10px 0 0;
                  white-space: normal;
                  word-wrap: break-word;
                  height: auto;
                "
                @close="handleRoughGridTagClose(index)"
                @click="showRoughGridModal(tag)"
              >
                格口号：{{ tag.grid_no }}； 中分位：{{ tag.hg_group }}
              </el-tag>
              <el-button
                type="primary"
                plain
                icon="el-icon-plus"
                @click="showRoughGridModal()"
              ></el-button>
            </el-col>
            <el-col :span="24">
              <el-form-item label="异常格口配置">
                <el-switch v-model="cutSettingForm.open_exception"></el-switch>
                <span> （开启后对应异常原因进入指定格口） </span>
              </el-form-item>
              <el-tag
                v-for="(tag, index) in cutSettingForm.exception_grid"
                :key="'tag-' + tag.grid_no + '-' + index"
                :disable-transitions="false"
                closable
                style="
                  margin: 10px 10px 0 0;
                  white-space: normal;
                  word-wrap: break-word;
                  height: auto;
                "
                @close="handleExceptionGridTagClose(index, 'cutSettingForm')"
                @click="showExceptionGridModal('fenbo', tag)"
              >
                格口号：{{ tag.grid_no }}； 异常原因：{{ tag.ex_text }}
              </el-tag>
              <el-button
                type="primary"
                plain
                icon="el-icon-plus"
                @click="showExceptionGridModal('fenbo')"
              ></el-button>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button
                  type="primary"
                  :loading="cutSettingLoading"
                  @click="saveCutSettingData"
                >
                  保存
                </el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>波次分播配置（配置仅对波次分播生效））</div>
        </div>
        <div style="padding: 20px 25px 0">
          <el-form :inline="true">
            <el-col :span="24">
              <el-form-item label="按波次分播区分中分板位配置：">
                <el-switch
                  v-model="is_open"
                  :active-value="constantMap.OPEN"
                  :inactive-value="constantMap.CLOSE"
                  @change="handleIsOpenChange"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-cascader
                  v-model="halveIds"
                  :options="halveOptions"
                  :props="{ multiple: true }"
                  placeholder="选择中分位"
                  collapse-tags
                  clearable
                  :show-all-levels="false"
                ></el-cascader>
              </el-form-item>
              <span>
                波次分播时只对配置中的波次进行分播，不在配置中的波次将进入以下格口
              </span>
              <el-tag
                v-for="(tag, index) in appointedGrid"
                :key="'tag-' + tag.grid_no + '-' + index"
                closable
                :disable-transitions="false"
                style="
                  margin: 10px 10px 0 0;
                  white-space: normal;
                  word-wrap: break-word;
                  height: auto;
                "
                @close="handleAppointedGridTagClose(index)"
              >
                格口号：{{ tag.grid_no }}； 中分位：
                <span
                  v-for="(hgid, i) in tag.hg_ids"
                  :key="'hgid-' + hgid.label + '-' + i"
                >
                  {{ hgid.label }},
                </span>
              </el-tag>
              <el-button
                type="primary"
                plain
                icon="el-icon-plus"
                @click="isAppointedGridModalVisible = true"
              ></el-button>
            </el-col>
            <el-col :span="24">
              <el-form-item label="异常格口配置">
                <el-switch
                  v-model="waveDistributionConfig.open_exception"
                ></el-switch>
                <span> （开启后对应异常原因进入指定格口） </span>
              </el-form-item>
              <el-tag
                v-for="(tag, index) in waveDistributionConfig.exception_grid"
                :key="'tag-' + tag.grid_no + '-' + index"
                :disable-transitions="false"
                closable
                style="
                  margin: 10px 10px 0 0;
                  white-space: normal;
                  word-wrap: break-word;
                  height: auto;
                "
                @close="
                  handleExceptionGridTagClose(index, 'waveDistributionConfig')
                "
                @click="showExceptionGridModal('wave', tag)"
              >
                格口号：{{ tag.grid_no }}； 异常原因：{{ tag.ex_text }}
              </el-tag>
              <el-button
                type="primary"
                plain
                icon="el-icon-plus"
                @click="showExceptionGridModal('wave')"
              ></el-button>
            </el-col>
            <el-col :span="24">
              <el-form-item label="">
                <el-switch
                  v-model="open_wave_grid"
                  :active-value="constantMap.OPEN_WAVE_GRID"
                  :inactive-value="constantMap.CLOSE_WAVE_GRID"
                ></el-switch>
                <span style="margin-right: 10px"> 当波次待发货数量≥</span>
                <YsInput
                  v-model="open_wave_num"
                  style="width: 100px"
                  pattern="positiveInt"
                >
                </YsInput>
                <span style="margin-left: 10px">则优先进入双数号格口</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button
                  type="primary"
                  :loading="cutSettingLoading"
                  @click="handleHalveDataSave"
                >
                  保存
                </el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.grid_no"
                      placeholder="格口"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.is_use" placeholder="是否开启">
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in is_use"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.is_check_one_out"
                      placeholder="是否一键打包"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option
                        v-for="item in is_check_one_out"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.picking_type"
                      placeholder="波次拣货属性"
                    >
                      <el-option label="显示全部" value=""></el-option>
                      <el-option
                        v-for="item in picking_type"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="search">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            type="primary"
            style="margin-left: auto"
            size="mini"
            @click="batch_dialog()"
            >批量编辑
          </el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="right"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column prop="grid_no" label="格口"></el-table-column>
            <el-table-column
              prop="is_use_txt"
              label="是否开启"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="grid_picking_type"
              label="波次拣货属性"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="grid_is_check_one_out"
              label="是否一键打包"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template #default="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="edit_grid(scope.row)"
                  >操作
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="resData.current_page"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.total"
            :page-size="form.pagesize"
            :page-sizes="[20, 50, 100]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="格口编辑" :visible.sync="dialogFormVisible" width="20%">
      <el-form :model="form">
        <el-form-item label="格口是否开启:">
          <el-select v-model="form.edit_is_use" placeholder="格口是否开启">
            <el-option
              v-for="item in is_use"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="波次拣货属性:">
          <el-select
            v-model="form.edit_picking_type"
            placeholder="波次拣货属性"
          >
            <el-option
              v-for="item in picking_type"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="一键打包:">
          <el-select
            v-model="form.edit_is_check_one_out"
            placeholder="一键打包"
          >
            <el-option
              v-for="item in is_check_one_out"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="edit_commit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="isShowComfirmModal"
      title="提示"
      width="30%"
      :before-close="handleSingleGridCancel"
    >
      <span
        >是否{{
          cutSettingForm.single_grid ? "打开" : "关闭"
        }}中分位分播时单件波次是否进入指定格口号功能？</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleSingleGridCancel">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSingleGridConfirm(cutSettingForm.single_grid)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="isOpenModalVisible"
      title="提示"
      width="30%"
      :before-close="handleOpenModalCancel"
    >
      <span
        >是否{{
          is_open === constantMap.OPEN ? "开启" : "关闭"
        }}按波次分播区分中分板位配置？</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleOpenModalCancel">取 消</el-button>
        <el-button type="primary" @click="handleOpenModalConfirm(is_open)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="isAppointedGridModalVisible"
      width="80%"
      :before-close="handleAppointedGridModalCancel"
    >
      <el-form
        ref="halveModalForm"
        :model="halveModalForm"
        :rules="halveModalFormRules"
      >
        <el-form-item
          prop="grid_no"
          label="格口号："
          :rules="{
            required: true,
            message: '格口号必填',
            trigger: 'blur',
          }"
          style="display: flex; width: 300px"
        >
          <el-input
            v-model="halveModalForm.grid_no"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="中分位分组："
          prop="hg_ids"
          :rules="{
            type: 'array',
            required: true,
            message: '中分位分组必选',
            trigger: 'change',
          }"
        >
          <div>
            <el-checkbox
              v-model="selectAllChecked"
              @change="selectAllHalveGroups"
              >全选
            </el-checkbox>
          </div>
          <div>
            <span v-for="(item, index) in selectedHgIds" :key="index">{{
              item
            }}</span>
          </div>
          <el-checkbox-group v-model="halveModalForm.hg_ids">
            <el-checkbox
              v-for="item in halveGroupIdOptions"
              :key="item.value"
              :label="item"
              border
              >{{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAppointedGridModalCancel">取 消</el-button>
        <el-button type="primary" @click="handleAppointedGridModalConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="粗分配置"
      :visible.sync="isRoughGridModalVisible"
      width="50%"
      @close="handleRoughGridModalCancel"
    >
      <el-form ref="roughModalForm" :model="roughModalForm">
        <el-form-item
          prop="grid_no"
          label="格口号："
          :rules="{
            required: true,
            message: '格口号必填',
            trigger: 'blur',
          }"
          style="display: flex; width: 300px"
        >
          <el-input
            v-model="roughModalForm.grid_no"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="中分位编码："
          prop="hg_ids"
          :rules="{
            type: 'array',
            required: true,
            message: '中分位粗分必选',
            trigger: 'change',
          }"
        >
          <el-cascader
            v-model="roughModalForm.hg_ids"
            :options="halveOptions"
            :props="{ multiple: true }"
            placeholder="选择中分位"
            clearable
            :show-all-levels="false"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleRoughGridModalCancel">取 消</el-button>
        <el-button type="primary" @click="handleRoughGridModalConfirm">
          确 定
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="异常格口配置"
      :visible.sync="isExceptionGridModalVisible"
      width="50%"
      @close="handleExceptionGridModalCancel"
    >
      <el-form ref="exceptionModalForm" :model="exceptionModalForm">
        <el-form-item
          prop="grid_no"
          label="格口号："
          :rules="{
            required: true,
            message: '格口号必填',
            trigger: 'blur',
          }"
          style="display: flex; width: 300px"
        >
          <el-input
            v-model="exceptionModalForm.grid_no"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="异常原因："
          prop="ex_ids"
          :rules="{
            type: 'array',
            required: true,
            message: '异常原因必选',
            trigger: 'change',
          }"
        >
          <el-select
            v-model="exceptionModalForm.ex_ids"
            multiple
            placeholder="选择原因"
            clearable
          >
            <el-option
              v-for="item in exceptionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleExceptionGridModalCancel">取 消</el-button>
        <el-button type="primary" @click="handleExceptionGridModalConfirm">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeaderTabs from "./components/HeaderTabs.vue";
import {
  postSetCutSetting,
  getGetCutSetting,
  getGetCutByWaveSetting,
  postSetCutByWaveSetting,
  getGetExceptionOps,
} from "@/openapi/erp/AdminSetting.js";
import {
  postGetHalveGroupDetailData,
  postGetHalveGroupData,
} from "@/openapi/erp/halveGroup.js";

const constantMap = Object.freeze({
  OPEN: 1, // 开启
  CLOSE: 2, // 关闭
  OPEN_ROUGH: "1", // 开启粗分
  CLOSE_ROUGH: "2", // 关闭粗分
  OPEN_EXCEPTION: "1", // 开启异常格口
  CLOSE_EXCEPTION: "2", // 关闭异常格口
  OPEN_WAVE_GRID: 1, // 开启波次待发货数量开关
  CLOSE_WAVE_GRID: 2, // 开启波次待发货数量开关
});
/**
 * 将级联多选中，选中的中分位格式化为提交所需格式。
 *
 * @param {Array} halveIds - 级联多选中选中的数据。
 * @returns {Array} - 格式化后的数据，包含中分位分组ID和对应的中分位ID数组。
 */
const formatHalveIdsForSubmit = (idPairs) => {
  if (!Array.isArray(idPairs) || idPairs.length === 0) {
    return [];
  }
  const groupedIds = new Map();

  idPairs.forEach(([hgId, hgdId]) => {
    if (!groupedIds.has(hgId)) {
      groupedIds.set(hgId, { hg_id: hgId, hgd_ids: [] });
    }
    groupedIds.get(hgId).hgd_ids.push(hgdId);
  });

  return Array.from(groupedIds.values());
};
/**
 * 将弹窗中指定的中分位数据格式化为提交所需格式。
 *
 * @param {Array} appointedGrid - 指定的中分位数据。
 * @returns {Array} - 格式化后的数组，包含格口号和对应的指定中分位分组id数组。
 */
const formatAppointedGridForSubmit = (appointedGrid) => {
  if (!Array.isArray(appointedGrid)) {
    return [];
  }
  return appointedGrid.map((item) => {
    const gridNo = typeof item.grid_no === "string" ? item.grid_no.trim() : "";
    const hgIds = Array.isArray(item.hg_ids)
      ? item.hg_ids.map((hg) => hg.value || "")
      : [];
    return { grid_no: gridNo, hg_ids: hgIds };
  });
};
/**
 * 将接口返回的的中分位数据，格式化为级联多选展示所需格式。
 *
 * @param {Array} checkedHg - 选中的中分位数组。
 * @returns {Array} - 格式化后的数组，包含中分位分组ID和对应的中分位ID数组。
 */
const formatHalveIdsForShow = (checkedHg) => {
  if (!Array.isArray(checkedHg) || checkedHg.length === 0) {
    return [];
  }
  const result = [];
  checkedHg.forEach((entry) => {
    const { hg_id: hgId, hgd_ids: hgdIds } = entry;
    hgdIds.forEach((item) => {
      result.push([hgId, item]);
    });
  });
  return result;
};
export default {
  components: { HeaderTabs },
  directives: {
    focus: {
      // 当绑定元素插入到 DOM 中。
      inserted(el) {
        // 聚焦元素
        el.children[0].focus();
      },
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      formName: "", // 分播 - fenbo, 波次 - wave
      waveDistributionConfig: {
        open_exception: "2",
        exception_grid: [],
      },
      constantMap,
      formatHalveIdsForSubmit,
      formatAppointedGridForSubmit,
      formatHalveIdsForShow,
      isShowComfirmModal: false,
      resData: {},
      form: {
        multipleSelection: [],
        pagesize: 20,
        edit_is_use: "",
        edit_picking_type: "",
        grid_ids: [],
        edit_is_check_one_out: "",
        grid_no: "",
        // dbid:'',
      },
      loading: false,
      url: "/erp/DeviceCut/gridList",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      checkVisible: false,
      dialogFormVisible: false,
      is_summary: 0, // 勾选的是否有汇总单的数据
      picking_type: [
        { key: "0", name: "全部" },
        { key: "4", name: "多件多波" },
        { key: "5", name: "多件少波" },
      ],
      is_use: [
        { key: "1", name: "开启" },
        { key: "2", name: "禁用" },
      ],
      is_check_one_out: [
        { key: "1", name: "是" },
        { key: "2", name: "否" },
      ],
      is_batch: false,
      cutSettingLoading: false,
      cutSettingForm: {
        auto_collect: false,
        grid_piece_num: "30",
        single_grid: false,
        grid_no: "",
        open_rough: "",
        rough_grid: [],
        open_exception: "",
        exception_grid: [],
      },
      halveIds: [], // 级联选中的数据，中分位Id数组
      halveOptions: [], // 中分位级联选择项
      halveGroupIdOptions: [], // 弹窗的中分位分组˙
      is_open: 2,
      open_wave_grid: "2",
      open_wave_num: 0,
      halveModalForm: {
        grid_no: "",
        hg_ids: [],
      },
      roughModalForm: {
        grid_no: "",
        hg_ids: [],
      },
      exceptionModalForm: {
        grid_no: "",
        ex_ids: [],
      },
      appointedGrid: [], // 弹窗设置的指定中分位

      isOpenModalVisible: false,
      isAppointedGridModalVisible: false,
      isRoughGridModalVisible: false, // 粗分配置弹窗
      isExceptionGridModalVisible: false, // 异常格口配置弹窗
      selectAllChecked: false,
      halveModalFormRules: {},
      fenboExceptionOptions: [], // 分播的异常原因选项
      waveExceptionOptions: [], // 波次异常的原因选项
    };
  },
  computed: {
    exceptionOptions() {
      return this.formName === "fenbo"
        ? this.fenboExceptionOptions
        : this.waveExceptionOptions;
    },
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
    selectedHgIds() {
      const hgLabels = this.halveModalForm.hg_ids.map((item) => item.label);
      return hgLabels.join("，");
    },
  },
  created() {
    this.fetchData();

    this.getHalveGroupDetail();
    this.getHalveGroupIdOptions();
    this.getCutByWaveSetting();
    this.getExceptionOptions();
  },
  methods: {
    async getExceptionOptions() {
      const res = await getGetExceptionOps();
      this.fenboExceptionOptions = res.hg_exceptions;
      this.waveExceptionOptions = res.wp_exceptions;
    },
    showRoughGridModal(tag) {
      if (tag) {
        this.roughModalForm = {
          grid_no: tag.grid_no,
          hg_ids: tag.hg_ids,
        };
      }
      this.isRoughGridModalVisible = true;
    },
    showExceptionGridModal(formName, tag) {
      if (tag) {
        this.exceptionModalForm = {
          grid_no: tag.grid_no || "",
          ex_ids: tag.ex_ids,
        };
      }
      this.formName = formName;
      this.isExceptionGridModalVisible = true;
    },
    spaceUp() {
      this.msgVisible = false;
      return false;
    },

    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      this.is_summary = 0;
      for (const key in val) {
        multipleSelection[key] = val[key].grid_id;
      }
      this.form.multipleSelection = multipleSelection;
    },
    onSubmit() {},
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          this.resData = res.data.data;
        } else {
          this.resData = res.data.data;
          this.curPage = 1;
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    edit_grid(row) {
      this.dialogFormVisible = true;
      this.$set(this.form, "edit_is_use", row.is_use);
      this.$set(this.form, "edit_picking_type", row.picking_type);
      this.$set(this.form, "grid_ids", [row.grid_id]);
      this.$set(this.form, "edit_is_check_one_out", row.is_check_one_out);
    },
    batch_dialog() {
      this.dialogFormVisible = true;
      this.$set(this.form, "edit_is_use", "");
      this.$set(this.form, "edit_picking_type", "");
      this.$set(this.form, "edit_is_check_one_out", "");
      this.is_batch = true;
    },
    edit_commit() {
      if (this.is_batch == true) {
        if (this.form.multipleSelection.length == 0) {
          this.$message.error("请先勾选格口数据");
          return false;
        }
        this.$set(this.form, "grid_ids", this.form.multipleSelection);
      }
      this.$http
        .post("/erp/DeviceCut/girdEdit", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success("保存成功");
            this.dialogFormVisible = false;
            this.fetchData();
          }
        });
      this.is_batch = false;
    },
    // 获取分播机设置
    getCutSettingData() {
      getGetCutSetting({}).then((res) => {
        const {
          auto_collect: autoCollect,
          grid_piece_num: gridPieceNum,
          single_grid: singleGrid,
          grid_no: gridNo,
          open_rough: openRough,
          rough_grid: roughGrid,
          open_exception: openException,
          exception_grid: exceptionGrid,
        } = res;
        // auto_collect、single_grid 为“1”：是，为“2”：否
        this.cutSettingForm = {
          grid_piece_num: gridPieceNum,
          auto_collect: autoCollect === "1",
          single_grid: singleGrid === "1",
          grid_no: gridNo,
          open_rough: openRough === constantMap.OPEN_ROUGH,
          rough_grid: roughGrid.map((item) => {
            const levelOne = this.halveOptions.find((it) => {
              return it.label === item.hg_group;
            });
            return {
              ...item,
              hg_ids: item.hgd_ids.map((it) => {
                return [levelOne && levelOne.value, it];
              }),
            };
          }),
          open_exception: openException === constantMap.OPEN_EXCEPTION,
          exception_grid: exceptionGrid.map((item) => {
            return {
              grid_no: item.grid_no,
              ex_ids: item.ex_ids,
              ex_text: item.ex_text,
            };
          }),
        };
      });
    },
    // 保存分播机设置
    saveCutSettingData() {
      this.cutSettingLoading = true;
      const {
        auto_collect: autoCollect,
        grid_piece_num: gridPieceNum,
        single_grid: singleGrid,
        grid_no: gridNo,
        open_rough: openRough,
        rough_grid: roughGrid,
        open_exception: openException,
        exception_grid: exceptionGrid,
      } = this.cutSettingForm;
      const roughGridFormat = roughGrid.map((item) => ({
        grid_no: item.grid_no,
        hgd_ids: item.hg_ids.map((hg) => hg[1]),
      }));
      const exceptionGridFormat = exceptionGrid.map((item) => ({
        grid_no: item.grid_no,
        ex_ids: item.ex_ids,
      }));
      const params = {
        grid_piece_num: gridPieceNum,
        auto_collect: autoCollect ? "1" : "2",
        single_grid: singleGrid ? "1" : "2",
        grid_no: singleGrid ? gridNo : "",
        open_rough: openRough
          ? constantMap.OPEN_ROUGH
          : constantMap.CLOSE_ROUGH,
        rough_grid: roughGridFormat,
        open_exception: openException
          ? constantMap.OPEN_EXCEPTION
          : constantMap.CLOSE_EXCEPTION,
        exception_grid: exceptionGridFormat,
      };
      postSetCutSetting(params)
        .then(() => {
          this.$message.success("分播设置成功");
          this.cutSettingLoading = false;
          this.getCutSettingData();
        })
        .finally(() => {
          this.cutSettingLoading = false;
        });
    },
    // 改变状态
    handleChangeOpen() {
      this.isShowComfirmModal = true;
    },
    // 切换中分位粗分状态
    handleSingleGridCancel() {
      this.$set(
        this.cutSettingForm,
        "single_grid",
        !this.cutSettingForm.single_grid
      );
      this.isShowComfirmModal = false;
    },
    handleSingleGridConfirm(isSingleGrid) {
      this.$set(this.cutSettingForm, "single_grid", isSingleGrid);
      if (isSingleGrid) {
        const { grid_no: gridNo } = this.cutSettingForm;
        const params = {
          grid_no: gridNo,
          single_grid: "1",
        };
        postSetCutSetting(params, { useDataField: false }).catch(() => {
          // 如果格口为空或者格口不符合要求,清空输入的格口数据
          this.$set(
            this.cutSettingForm,
            "single_grid",
            !this.cutSettingForm.single_grid
          );
          this.cutSettingForm.grid_no = "";
        });
      }
      this.isShowComfirmModal = false;
    },

    handleOpenModalCancel() {
      this.is_open =
        this.is_open === constantMap.OPEN
          ? constantMap.CLOSE
          : constantMap.OPEN;
      this.isOpenModalVisible = false;
    },
    handleOpenModalConfirm() {
      this.isOpenModalVisible = false;
    },
    handleAppointedGridModalCancel() {
      this.$refs.halveModalForm.resetFields();
      this.isAppointedGridModalVisible = false;
    },
    handleRoughGridModalCancel() {
      this.$refs.roughModalForm.resetFields();
      this.roughModalForm = this.$options.data().roughModalForm;
      this.isRoughGridModalVisible = false;
    },
    handleExceptionGridModalCancel() {
      this.$refs.exceptionModalForm.resetFields();
      this.exceptionModalForm = this.$options.data().exceptionModalForm;
      this.formName = "";
      this.isExceptionGridModalVisible = false;
    },
    handleAppointedGridModalConfirm() {
      this.$refs.halveModalForm.validate((valid) => {
        if (valid) {
          this.appointedGrid.push(this.halveModalForm);
          this.isAppointedGridModalVisible = false;
          this.halveModalForm = this.$options.data().halveModalForm;
          this.selectAllChecked = false;
        }
      });
    },
    handleRoughGridModalConfirm() {
      this.$refs.roughModalForm.validate((valid) => {
        if (valid) {
          // 粗分只能选择一个中分位(一级分类)
          const levelOneList = Array.from(
            new Set(this.roughModalForm.hg_ids.map((item) => item[0]))
          );
          if (levelOneList.length > 1) {
            this.$message.error("粗分只能选择一个中分位");
            return;
          }
          const newTarget = {
            ...this.roughModalForm,
            // 处理标签回显
            hg_group: this.halveOptions.find(
              (item) => item.value === this.roughModalForm.hg_ids[0][0]
            ).label,
          };
          const index = this.cutSettingForm.rough_grid.findIndex((item) => {
            return item.grid_no === newTarget.grid_no;
          });
          // 新增 push 编辑 replace
          if (index === -1) {
            this.cutSettingForm.rough_grid.push(newTarget);
          } else {
            this.cutSettingForm.rough_grid[index] = newTarget;
          }
          this.isRoughGridModalVisible = false;
          this.roughModalForm = this.$options.data().roughModalForm;
        }
      });
    },
    handleExceptionGridModalConfirm() {
      const key =
        this.formName === "fenbo" ? "cutSettingForm" : "waveDistributionConfig";
      this.$refs.exceptionModalForm.validate((valid) => {
        if (valid) {
          // const list = Array.from(new Set(this.exceptionModalForm.ex_ids));
          // if (list.length > 1) {
          //   this.$message.error("格口号配置重复");
          //   return;
          // }
          const newTarget = {
            ...this.exceptionModalForm,
            // 处理标签回显
            ex_text: this.exceptionModalForm.ex_ids
              .map((item) => {
                return this.exceptionOptions.find((it) => it.value === item)
                  .label;
              })
              .join("；"),
          };
          const index = this[key].exception_grid.findIndex((item) => {
            return item.grid_no === newTarget.grid_no;
          });
          // 新增 push 编辑 replace
          if (index === -1) {
            this[key].exception_grid.push(newTarget);
          } else {
            this[key].exception_grid[index] = newTarget;
          }
          this.isExceptionGridModalVisible = false;
          this.exceptionModalForm = this.$options.data().exceptionModalForm;
          this.$refs.exceptionModalForm.resetFields();
        }
      });
    },
    handleIsOpenChange() {
      this.isOpenModalVisible = true;
    },
    getHalveGroupDetail() {
      postGetHalveGroupDetailData()
        .then((res) => {
          this.halveOptions = res;
          this.getCutSettingData();
        })
        .catch(() => {
          this.$message.error("获取中分位数组失败~");
        });
    },
    getHalveGroupIdOptions() {
      postGetHalveGroupData({}).then((res) => {
        this.halveGroupIdOptions = res;
      });
    },
    getCutByWaveSetting() {
      getGetCutByWaveSetting().then((res) => {
        this.appointedGrid = [];
        this.is_open = res.is_open;
        this.open_wave_num = res.open_wave_num;
        this.open_wave_grid = res.open_wave_grid;
        this.halveIds = this.formatHalveIdsForShow(res.checked_hg);
        this.appointedGrid = res.appointed_grid.map((item) => ({
          grid_no: item.grid_no,
          hg_ids: item.hg_value,
        }));
        this.waveDistributionConfig.open_exception = res.open_exception === 1;
        this.waveDistributionConfig.exception_grid = res.exception_grid;
      });
    },
    selectAllHalveGroups() {
      this.halveModalForm.hg_ids = this.selectAllChecked
        ? [...this.halveGroupIdOptions]
        : [];
    },
    handleHalveDataSave() {
      const appointedGrid = this.formatAppointedGridForSubmit(
        this.appointedGrid
      );
      const params = {
        is_open: this.is_open,
        open_wave_grid: this.open_wave_grid,
        open_wave_num: this.open_wave_num,
        appointed_grid: appointedGrid,
        checked_hg: this.formatHalveIdsForSubmit(this.halveIds),
        open_exception: this.waveDistributionConfig.open_exception ? 1 : 2,
        exception_grid: this.waveDistributionConfig.exception_grid.map(
          (item) => {
            return {
              grid_no: item.grid_no,
              ex_ids: item.ex_ids,
            };
          }
        ),
      };
      postSetCutByWaveSetting(params).then((res) => {
        if (Object.keys(res).length === 0) {
          this.$message.success("保存成功~");
          this.getCutByWaveSetting();
        }
      });
    },
    handleAppointedGridTagClose(index) {
      this.$confirm("是否删除当前中分板位配置的格口?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.appointedGrid.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleRoughGridTagClose(index) {
      this.$confirm("是否删除当前中分板位配置的粗分格口?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.cutSettingForm.rough_grid.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleExceptionGridTagClose(index, field) {
      this.$confirm("是否删除当前异常格口配置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this[field].exception_grid.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1 rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/GridSetting.vue